import { Button, Switch, Tooltip } from "@mantine/core";
import { useEffect } from "react";
import { ComposeFormProvider, useComposeFormContext } from "shared/components/message/compose/context";
import { EscalationEditor } from "shared/components/message/compose/EscalationEditor";
import { useFormState } from "shared/hooks/useFormState";
import { useAside } from "shared/utils/aside";

export const AcknowledgementsSwitch = () => {
    const aside = useAside();
    const form = useComposeFormContext();

    const [escalations] = useFormState(form, "escalations");
    const [acknowledgable] = useFormState(form, "acknowledgable");

    useEffect(() => {
        if (!acknowledgable) aside.dismiss();
    }, [acknowledgable]);

    return (
        <>
            <Tooltip
                label="You must remove escalations in order to disable acknowledgement"
                refProp="rootRef"
                disabled={escalations.length == 0}
            >
                <Switch
                    label="Enable Acknowledgments"
                    disabled={escalations.length > 0}
                    py="sm"
                    {...form.getInputProps("acknowledgable", { type: "checkbox" })}
                />
            </Tooltip>
            {acknowledgable && (
                <Button
                    variant="default"
                    onClick={() =>
                        aside.present({
                            label: "Escalation Policy",
                            component: (
                                <ComposeFormProvider form={form}>
                                    <EscalationEditor />
                                </ComposeFormProvider>
                            ),
                        })
                    }
                >
                    Escalation Policy
                </Button>
            )}
        </>
    );
};
